// * Bootstrap libraries
import './_bootstrap';

// * Headroom: oculta la cabecera al bajar y la muestra al subir
import Headroom from 'headroom.js';

(function (Drupal, once) {
  Drupal.behaviors.mainHeader = {
    attach(context) {
      once('headroom', 'nav.navbar', context).forEach((navbar) => {
        new Headroom(navbar, {
          offset: 80,
          tolerance: 5,
        }).init();
      });
    },
  };
}(Drupal, once));
